import { FunctionField, ReferenceField } from 'react-admin'
import { labTestResultLabels } from '../../../utils/constants'
import { client } from '../../../providers/data/client'

// Field Helpers

export const isResultDetailsRestricted = (kit) => ['pendingConfirmation', 'manualReview'].includes(kit?.status)

export const isTestComplete = (kit) => {
  return Number(kit?.labTestedAt) > 0 && !isResultDetailsRestricted(kit)
}

export const getLabTestResultPdf = async (kit, notify) => {
  try {
    const response = await client().get(`/provider-portal/results/${kit.kitId.toString()}/resultPdf`)

    let d = response.data.response
    if (d.url) {
      window.open(d.url)
    } else {
      let errorMessage = JSON.stringify(d)
      notify(errorMessage, {
        type: 'error',
        undoable: false,
        multiLine: true,
      })
    }
  } catch (error) {
    let errorMessage = 'Failed to retrieve Lab Test Result PDF for Kit ' + kit.kitId.toString()

    if (error.response.data.message) {
      errorMessage = error.response.data.message
    } else if (error.response.data.error) {
      errorMessage = error.response.data.error
    } else if (error.message) {
      errorMessage = error.message
    }

    notify(errorMessage, { type: 'error', multiLine: true, undoable: false })
  }
}

export const formatProviders = (provider) => {
  if (!provider) {
    return 'Not Assigned'
  }
  var providerDetail = []

  // Provider Display Name (link)
  providerDetail.push(<>{provider.displayName}</>)

  // City, State
  if (provider.city) {
    providerDetail.push(
      <>
        {provider.city} {provider.state && `,${provider.state}`}
      </>
    )
  }

  // Fax #
  providerDetail.push(
    <>
      <span className="fa-solid fa-fax" aria-hidden="true" title="Fax Number"></span>&nbsp;{provider.fax || '-'}
    </>
  )

  // Fax prefs
  providerDetail.push(<>Fax prefs:</>)
  if (provider.faxNegativeResults === 'Yes' && provider.faxPositiveResults === 'Yes') {
    providerDetail.push(
      <>
        <b>Positive</b> and <b>NSS</b>
      </>
    )
  } else if (provider.faxNegativeResults === 'Yes') {
    providerDetail.push(
      <>
        <b>NSS</b> only
      </>
    )
  } else if (provider.faxPositiveResults === 'Yes') {
    providerDetail.push(
      <>
        <b>Positive</b> only
      </>
    )
  } else {
    providerDetail.push(<span>none</span>)
  }

  return providerDetail
}

export const providerNotesIcon = (kit) => {
  return (
    kit &&
    kit.labTestProviderNotes && (
      <span style={{ marginLeft: 8, color: '#9f0000' }} className="fa-solid fa-exclamation-circle fa-lg tooltip">
        <p className="tooltiptext">{kit.labTestProviderNotes && kit.labTestProviderNotes.replace(/"/g, '&quot;')}</p>
      </span>
    )
  )
}

export const labTestResultLabel = (kit) => {
  if (isResultDetailsRestricted(kit)) {
    const label = kit.status === 'manualReview' ? 'Manual Review' : 'Pending Confirmation'
    return <span className="pill pill-neutral">{label}</span>
  }

  var result = kit.labTestResult
  var resultGrade = ''
  var l = <span className="pill pill-neutral">Not Tested</span>

  if (result === 'Positive') {
    resultGrade += ' (' + kit.labTestSampleGrade + ')'
  }

  for (let v of labTestResultLabels) {
    if (v.value === result) {
      l = (
        <span nowrap className={`pill ${v.label}`}>
          {result === 'none' ? 'Not Tested' : result + resultGrade}
        </span>
      )
      break
    }
  }

  var labDetail = ''
  if (result) {
    labDetail += kit.labTestResult
    if (kit.labTestSampleGrade !== 'NONE') {
      labDetail += ' (' + kit.labTestSampleGrade + ')'
    }
    //    labDetail += ' ... '
    //    labDetail += (kit.labTestedAt ? fromTimestamp(kit.labTestedAt) : '') + ' by ' + (kit.labTestedBy ? kit.labTestedBy : 'unknown')
    return <span title={labDetail}>{l}</span>
  } else {
    return l
  }
}

export const labTestResultLabelWithNotes = (kit) => {
  if (isResultDetailsRestricted(kit)) {
    return <span style={{ whiteSpace: 'nowrap' }}>{labTestResultLabel(kit)}</span>
  }

  return (
    <span style={{ whiteSpace: 'nowrap' }}>
      {labTestResultLabel(kit)}
      &nbsp;
      {providerNotesIcon(kit)}
    </span>
  )
}

export const weeksSinceVasectomyLabel = (kit) => {
  if (kit.weeksSinceVasectomy && kit.weeksSinceVasectomy > 0) {
    return (
      <p>
        <span className="label"> {kit.weeksSinceVasectomy}</span> weeks
      </p>
    )
  }
  return ''
}

// Fields
export const ProviderField = () => {
  return (
    <ReferenceField source="providerId" reference="provider-portal/providers" link="show">
      <FunctionField render={(record) => formatProviders(record).map((item, index) => <p key={index}>{item}</p>)} />
    </ReferenceField>
  )
}

// ResultDetailPdf
//  Show PDF icon to download test result
export const ResultDetailPdf = ({ notify, record }) => {
  if (isResultDetailsRestricted(record)) {
    return <div aria-hidden="true" />
  }

  return (
    <div>
      {isTestComplete(record) && (
        <button
          type="button"
          className="icon-btn-ghost"
          title="Test Result PDF"
          aria-label="Download PDF report"
          onClick={async () => await getLabTestResultPdf(record, notify)}
        >
          <span className="fa-solid fa-file-pdf" style={{ fontSize: 18 }} aria-hidden="true"></span>
        </button>
      )}
    </div>
  )
}
